export function getDate8(){
  return format(new Date(),'yyyyMMdd')
}

export function getDateTime14(){
  return format(new Date(),'yyyyMMddHHmmss')
}

export function getDateTime(){
  return format(new Date(),'yyyy-MM-dd HH:mm:ss')
}

/**
 * 字符串转为Date对象，失败返回null
 *
 *  2006-1-1 、2006-01-01 00:00、2006-01-01 00:00:00、 <br>
 *            20060101、200601011845、20060101184503
 *
 * @param obj
 */
export function valueOf (obj) {
  let date = null
  if (!obj) {
    return date
  }
  if (obj instanceof Date) {
    return obj
  }
  let reg = /^\d{8}|\d{12}|\d{14}$/
  obj = String(obj) // create_time为14位时间的long型数值，此处转为字符串处理
  if (reg.test(obj)) {
    switch (obj.length) {
      case 8:
        date = valueOf(obj.substring(0, 4) + '/' + obj.substring(4, 6) + '/' + obj.substring(6))
        break
      case 12:
        date = valueOf(obj.substring(0, 4) + '/' + obj.substring(4, 6) + '/' + obj.substring(6, 8) + ' ' + obj.substring(8, 10) + ':' + obj.substring(10, 12) + ':00')
        break
      case 14:
        date = valueOf(obj.substring(0, 4) + '/' + obj.substring(4, 6) + '/' + obj.substring(6, 8) + ' ' + obj.substring(8, 10) + ':' + obj.substring(10, 12) + ':' + obj.substring(12))
        break
    }
  } else {
    if (obj.indexOf(':') === -1) {
      obj = obj + ' 00:00:00'
    } else if ((obj.indexOf(':') !== -1 && obj.endsWith(':') === false) && obj.substring(obj.indexOf(':') + 1).indexOf(':') === -1) {
      obj = obj + ':00'
    }
    try {
      date = new Date(obj)
      if (date.toString() === 'Invalid Date') {
        date = null
      }
    } catch (ex) {
    }
  }
  return date
}

/**
 * 格式化日期对象：yyyyMMdd HH:mm:ss
 * @param obj
 * @param pattern
 * @returns {*}
 */
export function format (obj, pattern) {
  if (!obj) {
    return ''
  }
  if (obj instanceof Date) {
    var o = {
      'M+': obj.getMonth() + 1, // 月份
      'd+': obj.getDate(), // 日
      'H+': obj.getHours(), // 小时
      'm+': obj.getMinutes(), // 分
      's+': obj.getSeconds(), // 秒
      'q+': Math.floor((obj.getMonth() + 3) / 3), // 季度
      'S': obj.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(pattern)) {
      pattern = pattern.replace(RegExp.$1, (obj.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(pattern)) {
        pattern = pattern.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return pattern
  }
  return format(valueOf(obj), pattern)
}

/**
 * d1 - d2 的秒数
 * @param d1 js传过来的：时间戳、日期字符串、日期对象
 * @param d2 js传过来的：时间戳、日期字符串、日期对象
 */
export function getSecondsInterval(d1, d2) {
  var date1 = valueOf(d1)
  var date2 = valueOf(d2)
  if (!date1 ||!date2) {
    return null
  }
  var timeDiff = date1.getTime() - date2.getTime()
  // 将时间戳差值转换为秒
  return Math.floor(timeDiff / (1000))
}

/**
 * d1 - d2 的分钟数
 * @param d1 js传过来的：时间戳、日期字符串、日期对象
 * @param d2 js传过来的：时间戳、日期字符串、日期对象
 */
export function getMinutesInterval(d1, d2) {
  var date1 = valueOf(d1)
  var date2 = valueOf(d2)
  if (!date1 ||!date2) {
    return null
  }
  var timeDiff = date1.getTime() - date2.getTime()
  // 将时间戳差值转换为秒
  return Math.floor(timeDiff / (1000 * 60))
}

/**
 * d1 - d2 的天数
 * @param d1 js传过来的：时间戳、日期字符串、日期对象
 * @param d2 js传过来的：时间戳、日期字符串、日期对象
 */
export function getDaysInterval(d1, d2) {
  var date1 = valueOf(d1)
  var date2 = valueOf(d2)
  if (!date1 ||!date2) {
    return null
  }
  var timeDiff = date1.getTime() - date2.getTime()
  // 将时间戳差值转换为秒
  return Math.floor(timeDiff / (1000 * 3600 * 24))
}

/**
 * 日期加天数
 *
 * @param obj 日期
 * @param num  加数
 * @return
 */
export function addDays(obj,num) {
  const date = valueOf(obj)
  if (!date) return null
  date.setDate(date.getDate() + num)
  return date
}
